const mutations = {
  mutationPaymentToInsurerTransaction(state, payload) {
    state.paymentToInsurerTransaction = payload;
  },

  mutationPaymentToInsurerTransactionList(state, payload) {
    if (payload && (payload.tab || payload.tab === 0)) {
      state.paymentToInsurerTransactionList[payload.tab] = payload.responseData;
    } else {
      state.paymentToInsurerTransactionList = payload;
    }
  },

  mutationPaymentToInsurerTransactionMeta(state, payload) {
    state.paymentToInsurerTransactionMeta = payload;
  },

  mutationInsurerBranchList(state, payload) {
    state.insurerBranchList = payload;
  },

  resetInsurerBranchList(state) {
    state.insurerBranchList = [];
  },

  mutationSelectedInsurer(state, payload) {
    state.selectedInsurer = payload;
  },

  mutationFetchParameter(state, payload) {
    state.fetchParameter = payload;
  },
};

export default mutations;
